<template>
  <section class="col">
    <UserProfileNewUserSubscriptions
      v-if="(this.isNavigationVisible && this.activeTab == this.profileTab.Subscription) || !this.isNavigationVisible"
      :subscription-plans="subscriptionPlans"
      @SelectPlan="SelectPlan"
    />
    <div class="d-flex flex-row row">
      <!-- <div class="d-flex flex-column col-md-6 col-xxs-12 my-4">
          <UserProfileNewUserReferral :ReferUrl="ReferUrl"></UserProfileNewUserReferral>
          <UserProfileNewUserVoucherCard></UserProfileNewUserVoucherCard>
        </div>
      <UserProfileNewUserWallet></UserProfileNewUserWallet>-->
      <UserProfileSubscribedUserWallet
        v-if="(this.isNavigationVisible && this.activeTab == this.profileTab.Wallet) || !this.isNavigationVisible"
        :accounting="accounting"
        :subscription-plan="subscriptionPlan"
        :refer-url="referUrl"
        :user="this.user"
        @ShowPaymentHistory="ShowPaymentHistory"
      />
    </div>
  </section>
</template>

<script>
import UserProfileNewUserReferral from '@/components/UserProfileNewUserReferral.vue'
import UserProfileNewUserSubscriptions from '@/components/UserProfileNewUserSubscriptions.vue'
import UserProfileNewUserVoucherCard from '@/components/UserProfileNewUserVoucherCard.vue'
import UserProfileNewUserWallet from '@/components/UserProfileNewUserWallet.vue'
import UserProfileSubscribedUserWallet from '@/components/UserProfileSubscribedUserWallet.vue'
import { mapActions } from 'vuex'
import utility from '@/utilities/utility'
import enums from '@/utilities/enums.js'

export default {
  name: 'UserProfileNew',
  components: {
    UserProfileNewUserReferral,
    UserProfileNewUserSubscriptions,
    UserProfileNewUserWallet,
    UserProfileNewUserVoucherCard,
    UserProfileSubscribedUserWallet
  },
  mixins: [enums],
  props: {
    subscriptionPlans: Array,
    subscriptionPlan: Object,
    accounting: Object,
    referUrl: String,
    isNavigationVisible: Boolean,
    activeTab: String,
    user: Object
  },
  methods: {
    ...mapActions({
      setSubscriptionPlan: 'order/setSubscriptionPlan'
    }),
    ShowPaymentHistory () {
      this.$emit('ShowPaymentHistory')
    },
    SelectPlan (selectedPlan) {
      this.setSubscriptionPlan(selectedPlan)
      this.$router.push({ path: 'buysubscriptionfactor' })
    }
  }
}
</script>
